var React = require('react');

function Donestepicon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M22.81 4.94a1.5 1.5 0 0 1 0 2.12L9 20.872l-7.06-7.06a1.5 1.5 0 0 1 2.12-2.122L9 16.63l11.69-11.69a1.5 1.5 0 0 1 2.12 0z","fill":"#000"}));
}

Donestepicon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Donestepicon;

Donestepicon.default = Donestepicon;
